"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedPriceOracleFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_price",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "assetPrices",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
        ],
        name: "getUnderlyingPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "isPriceOracle",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "price",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b5060405161012d38038061012d8339818101604052602081101561003357600080fd5b505160005560e7806100466000396000f3fe6080604052348015600f57600080fd5b506004361060465760003560e01c80635e9a523c14604b57806366331bba146080578063a035b1fe14609a578063fc57d4df14604b575b600080fd5b606e60048036036020811015605f57600080fd5b50356001600160a01b031660a0565b60408051918252519081900360200190f35b608660a7565b604080519115158252519081900360200190f35b606e60ac565b5060005490565b600181565b6000548156fea265627a7a7231582096fce0257cc5bb7c1b6c1385226722dfbd11d7b10c97b8ea854f77349f5c52e064736f6c63430005100032";
class FixedPriceOracleFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_price, overrides) {
        return super.deploy(_price, overrides || {});
    }
    getDeployTransaction(_price, overrides) {
        return super.getDeployTransaction(_price, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.FixedPriceOracleFactory = FixedPriceOracleFactory;
FixedPriceOracleFactory.bytecode = _bytecode;
FixedPriceOracleFactory.abi = _abi;
//# sourceMappingURL=FixedPriceOracleFactory.js.map